// src/data/songs.js
const songs = [
  {
    id: "1",
    title: "Games",
    artist: "Dina Ayada",
    cover: "/games.jpg",
    src: "/games.mp3"
  },
  {
    id: "2",
    title: "Heat waves",
    artist: "Glass Animals",
    cover: "/heat_waves.jpg",
    src: "/heat_waves.mp3"
  },
  {
    id: "3",
    title: "B Who I Want 2 B",
    artist: "安室奈美恵, 初音ミク",
    cover: "/b_who_i_want_2_b.jpg",
    src: "/b_who_i_want_2_b.mp3"
  },
  {
    id: "4",
    title: "Born This Way",
    artist: "Lady Gaga",
    cover: "/born_this_way.jpg",
    src: "/born_this_way.mp3"
  }
];

export default songs;
